module.exports = __webpack_public_path__ + "static/media/g7.18514d85.jpg";